/**
 * Application main entry point.
 */
import React, { ComponentType } from "react";
import ReactDOM from "react-dom";

import ErrorBoundary from "./components/ErrorBoundary";
import { captureException } from "@utils/error";
import { initializeSentry } from "@utils/error/sentry";
import { preloadPagePath } from "./router";
import { triggerLoadPhase } from "./vendor";
import { PageSetRouter } from "./pageDefinitions/components/PageSetRouter";

// Set up sentry error handling so we can capture any errors as early as possible.
initializeSentry();

(window as any).serverContext = {};

export async function boot(App: ComponentType): Promise<void> {
  try {
    // Preload the current page chunk
    preloadPagePath(window.location.pathname);

    triggerLoadPhase("bootstrap");

    ReactDOM.render(
      <ErrorBoundary>
        <PageSetRouter>
          <App />
        </PageSetRouter>
      </ErrorBoundary>,
      document.getElementById("root")
    );
  } catch (err) {
    captureException(err, "bootstrap");
  }
}
